import { Directive, ElementRef, Input, Renderer, OnChanges } from '@angular/core';
import { FileSizePipe } from '../pipe/fileSizePipe.pipe';
export class ProgressBarDirective implements OnChanges {
     progress: any;
/**
 * @param {?} el
 * @param {?} renderer
 */
constructor(private el: ElementRef,
private renderer: Renderer) { }
/**
 * @return {?}
 */
ngOnChanges() {
        let /** @type {?} */ el = this.el;
        el.nativeElement.value = this.progress.percent;
        if (this.progress.speed > 0) {
            let /** @type {?} */ pipe = new FileSizePipe();
            this.renderer.setElementAttribute(this.el.nativeElement, 'speedText', pipe.transform(this.progress.loaded));
        } else {
            this.renderer.setElementAttribute(this.el.nativeElement, 'speedText', '');
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: 'progress[progressBar]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'progress': [{ type: Input },],
};
}

function ProgressBarDirective_tsickle_Closure_declarations() {
/** @type {?} */
ProgressBarDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProgressBarDirective.ctorParameters;
/** @type {?} */
ProgressBarDirective.propDecorators;
/** @type {?} */
ProgressBarDirective.prototype.progress;
/** @type {?} */
ProgressBarDirective.prototype.el;
/** @type {?} */
ProgressBarDirective.prototype.renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
